// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { TooltipTokens } from './type';

const tooltipTokens: TooltipTokens = {
  tooltipFontSize: '12/regular',
  tooltipPaddingX: 'Padding-8',
  tooltipPaddingY: 'Padding-5',
  tooltipBorderRadius: 'Radius-2',
  tooltipColor: 'Neutral-text-1',
  tooltipShadow: 'Shadow-2',
  tooltipBackgroundColor: 'Neutral-fill-9',
  tooltipLightColor: 'Neutral-text-5',
  tooltipLightBackgroundColor: 'Neutral-fill-1',
  tooltipLightBorderColor: 'Neutral-border-1',
  tooltipPrimaryColor: 'Brand-6',
  tooltipPrimaryBackgroundColor: 'Brand-1',
  tooltipSuccessColor: 'Success-7',
  tooltipSuccessBackgroundColor: 'Success-1',
  tooltipWarningColor: 'Warning-7',
  tooltipWarningBackgroundColor: 'Warning-1',
  tooltipDangerColor: 'Danger-7',
  tooltipDangerBackgroundColor: 'Danger-1',
};

export default tooltipTokens;
